"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var apiBase = window.location.protocol.startsWith("https") ? "https://zoilerroom.live:8443/" : "http://zoilerroom.live:8000/";
var statusJson = "status-json.xsl";
var moveClients = "admin/moveclients?";
exports.default = {
    isLoggedIn: function () {
        var pw = localStorage.getItem("password");
        return pw && pw.length > 0;
    },
    setPassword: function (password) {
        localStorage.setItem("password", password);
    },
    logout: function () {
        localStorage.removeItem("password");
    },
    //getAuthHeader(): AxiosRequestConfig {
    //  //let password = localStorage.getItem("password");
    //  return ;
    //},
    getStatus: function () {
        return axios_1.default.get(apiBase + statusJson);
    },
    moveToMountpoint: function (dest, source) {
        //window.open(apiBase + moveClients + `mount=/${source.toLowerCase()}&destination=/${dest.toLowerCase()}`, "_blank");
        var ifrm = document.createElement('iframe');
        ifrm.style.display = "none";
        ifrm.src = apiBase + moveClients + ("mount=/" + source + "&destination=/" + dest);
        document.body.appendChild(ifrm);
        setTimeout(function () { return document.body.removeChild(ifrm); }, 5000);
        //let password = localStorage.getItem("password");
        //let x = new XMLHttpRequest();
        //x.open(
        //  "GET",
        //  apiBase + moveClients + `mount=/${source.toLowerCase()}&destination=/${dest.toLowerCase()}`,
        //  false, 'admin', password);
        //x.setRequestHeader("Authorization", "Basic " + btoa("admin:" + password));
        //x.setRequestHeader("Host", "zoilerroom.live:8000");
        //x.send(null);
        //x.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9");
        //let promise = axios.get(
        //  apiBase + moveClients + `mount=/${source.toLowerCase()}&destination=/${dest.toLowerCase()}`, 
        //  {
        //    auth: {
        //      username: 'admin',
        //      password: password
        //    }, 
        //    method: "GET"
        //  });
        //promise.then(result => console.log(result)).catch(err => console.log(err));
    }
};
var Icecastserver = /** @class */ (function () {
    function Icecastserver() {
    }
    return Icecastserver;
}());
exports.Icecastserver = Icecastserver;
var Icestats = /** @class */ (function () {
    function Icestats() {
    }
    return Icestats;
}());
exports.Icestats = Icestats;
//# sourceMappingURL=api.js.map